import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, FormGroup, FormArray, FormControl, Validators  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { DataService } from '../../../data.service';
import { CommonService } from '../../../services/common.service';
import { AppData } from '../../../constants/app-data';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";

@Component({
  selector: 'app-comp-sub-mapping',
  templateUrl: './comp-sub-mapping.component.html',
  styleUrls: ['./comp-sub-mapping.component.css']
})
export class CompSubMappingComponent implements OnInit {
	
  private _competitionType;
  private _subjectType;
  private _compSubMapping;
   
  private loginUserByParam;

  public competitionType : any; //= [];
  public competitionSubjectMapping : any; //= [];
  public indivCompetitionSubjectMapping : any ; //= [];
  
  constructor( private formBuilder: FormBuilder, private routeParams: ActivatedRoute,
  			public appData: AppData, private dataService: DataService, private commonService: CommonService,
  			public notificationService: NotificationService) { }

  indivCompSubMapping =  new FormGroup({
  	 compSubList: new FormArray([]),
     indivCompSubList: new FormArray([])
  });
  indivCompSubMappingDefaultData = {
  	compSubList : [],
  	indivCompSubList : []
  }
  
  //Below method is used in html files as well. otherwise html gives error
  get compSubArray(){
  	return this.indivCompSubMapping.controls.compSubList as FormArray;
  }
  
  //Below method is used in html files as well. otherwise html gives error
  get indivCompSubArray(){
  	return this.indivCompSubMapping.controls.indivCompSubList as FormArray;
  }
	  	  
  getCompSubForm(noOfQuestion,testTimeoutMinute,markCA,markWA,markSA){
    return this.formBuilder.group({
    //return new FormGroup({
	    id: new FormControl(''),    
	    competitionType: new FormControl(''),
	    competitionTypeDesc: new FormControl(''),
	    subjectType: new FormControl(''),
	    subjectTypeDesc: new FormControl(''),
	    noOfQuestionsToAttempt: new FormControl(noOfQuestion, [ Validators.maxLength(3) ]),
	    testTimeoutMinute: new FormControl(testTimeoutMinute, [ Validators.maxLength(3) ]),
	    marksCorrectAnswer: new FormControl(markCA, [ Validators.maxLength(3) ]),
	    marksWrongAnswer: new FormControl(markWA, [ Validators.maxLength(3) ]),
	    marksSkipAnswer: new FormControl(markSA, [ Validators.maxLength(3) ])
	    // registrationNo: new FormControl('', [ Validators.minLength(6), Validators.maxLength(30) ]),
	    //educationalSystemTypeStr: new FormControl(''),
	   
	  });
   }
   
    getIndivCompSubForm(){
    return this.formBuilder.group({
    //return new FormGroup({
	    id: new FormControl(''),
	    competitionType: new FormControl(''),
	    competitionTypeDesc: new FormControl(''),
	    subjectType: new FormControl(''),
	    subjectTypeDesc: new FormControl(''),
	    noOfQuestionsToAttempt: new FormControl('', [ Validators.maxLength(3) ]),
	    testTimeoutMinute:  new FormControl('', [ Validators.maxLength(3) ]),
	    marksCorrectAnswer: new FormControl('1.0', [ Validators.maxLength(3) ]),
	    marksWrongAnswer: new FormControl('0.0', [ Validators.maxLength(3) ]),
	    marksSkipAnswer: new FormControl('0.0', [ Validators.maxLength(3) ])
	   // registrationNo: new FormControl('', [ Validators.minLength(6), Validators.maxLength(30) ]),
	    //educationalSystemTypeStr: new FormControl(''),
	   
	  });
   }
  ngOnInit(): void {
	//console.log("userId:"+this.appData.userId);
	this.loginUserByParam = this.routeParams.snapshot.params['userLoginId'];
	let indivUserCompanyId = this.routeParams.snapshot.params['companyId'];
	//console.log("this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
	//console.log("this.loginUserByParam:" + this.loginUserByParam  + ", indivUserCompanyId:" + indivUserCompanyId );
	
	
	this.appData.isAuthenticated.subscribe(message=> {
		//console.log("com-sub-mapp::Authenticated:"+message+", loginUserId" + this.appData.userId);
		if(message === true) {
	
		
		if(this.loginUserByParam  === undefined || this.loginUserByParam  === null){
			if(this.appData.userId === 'Admin'){
				this.loginUserByParam = this.appData.userId ;
			} else {
				return;
			}
		}
		
		
		
	  	let ctBody = {"loginUserId" : this.loginUserByParam , "type" : "competitionType"};
	  	//Competition Type list
	  	this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCompTypeList, ctBody).subscribe((res: any)=>{
	      //console.log(res);
	      this._competitionType = res.data;
	      
	    });
	    let stBody = {"loginUserId" : this.loginUserByParam , "type" : "subjectType"};
	    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCompTypeList, stBody).subscribe((res: any)=>{
	      //console.log(res);
	      this._subjectType = res.data;
	    });
	    	//console.log("1com-sub-mapp:: loginUserId" + this.appData.userId);
		
	    		this.retrieveCompSubMapping();
		
	    
	    this.retrieveIndivCompSubMapping(this.loginUserByParam);
    }
    });
  }
  
  retrieveCompSubMapping(){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : this.appData.userId};
    //Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCompSubTypeList, body).subscribe((res: any)=>{
      //console.log(res);
      this.competitionSubjectMapping = res.data.list;
      if(this.competitionSubjectMapping != undefined && this.competitionSubjectMapping.length > 0){
        //console.log('this.competitionSubjectMapping.length:' + this.competitionSubjectMapping.length);
        //let temp = indivCompSubMappingDefaultData; //{ 'compSubList' : [] }
      	for(let i=0; i<this.competitionSubjectMapping.length; i++){
			var tempcsm = this.competitionSubjectMapping[i];
			this.compSubArray.push(this.getCompSubForm(tempcsm.noOfQuestion,tempcsm.testTimeoutMinute,tempcsm.marksCorrectAnswer,tempcsm.marksWrongAnswer,tempcsm.marksSkipAnswer) );
      		this.indivCompSubMappingDefaultData.compSubList.push(this.competitionSubjectMapping[i]);
      	}
      	this.indivCompSubMapping.patchValue(this.indivCompSubMappingDefaultData);      	
      }
      
    });
  }

  retrieveIndivCompSubMapping(indivLoginEmailId){
  	// let body = {"loginUserId" : this.appData.userId, "type" : "Software_Evaluation"};
  	  let body = {"loginUserId" : indivLoginEmailId};
    //Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesIndivCompSubMappingList, body).subscribe((res: any)=>{
      //console.log(res);
      this.indivCompetitionSubjectMapping = res.data.list;
      if(this.indivCompetitionSubjectMapping != undefined && this.indivCompetitionSubjectMapping.length > 0){
        //console.log('this.indivCompetitionSubjectMapping.length:' + this.indivCompetitionSubjectMapping.length);
        //let temp = indivCompSubMappingDefaultData; //{ 'indivCompSubList' : [] }
        let len = this.indivCompSubArray.length;
      	for(let ix=0; ix<len; ix++){
      		this.indivCompSubArray.removeAt(0);
      		this.indivCompSubMappingDefaultData.indivCompSubList.splice(0,1);
      	}
      	//this.indivCompSubMappingDefaultData.indivCompSubList =[];
      	for(let i=0; i<this.indivCompetitionSubjectMapping.length; i++){
      		//let temp = this.indivCompetitionSubjectMapping[i].indivCompSubList[0];
      		//temp.id = this.indivCompetitionSubjectMapping[i].id;
      		//temp.noOfQuestionsToAttempt = this.indivCompetitionSubjectMapping[i].noOfQuestionsToAttempt;
      		var tempcsm = this.indivCompetitionSubjectMapping[i];
      		this.indivCompSubArray.push(this.getCompSubForm(tempcsm.noOfQuestionsToAttempt,tempcsm.testTimeoutMinute,tempcsm.marksCorrectAnswer,tempcsm.marksWrongAnswer,tempcsm.marksSkipAnswer) );
      		this.indivCompSubMappingDefaultData.indivCompSubList.push(this.indivCompetitionSubjectMapping[i].compSubMappingList[0]);
      		this.indivCompSubMappingDefaultData.indivCompSubList[i].id = this.indivCompetitionSubjectMapping[i].id;
      	}
      	    
      		this.indivCompSubMapping.patchValue(this.indivCompSubMappingDefaultData); 	 	
      }
    });
  }

  editIndivCompSubMapping(index){
  	let body = this.getDefaultData();
  	body.noOfQuestionsToAttempt = this.indivCompSubMapping.value.indivCompSubList[index].noOfQuestionsToAttempt;
  	body.testTimeoutMinute = this.indivCompSubMapping.value.indivCompSubList[index].testTimeoutMinute;
  	body.marksCorrectAnswer = this.indivCompSubMapping.value.indivCompSubList[index].marksCorrectAnswer;
  	body.marksWrongAnswer = this.indivCompSubMapping.value.indivCompSubList[index].marksWrongAnswer;
  	body.marksSkipAnswer = this.indivCompSubMapping.value.indivCompSubList[index].marksSkipAnswer;
  	body.id = this.indivCompSubMapping.value.indivCompSubList[index].id;
  	body.compSubMappingList.push(this.indivCompetitionSubjectMapping[index].compSubMappingList[0]);
  	body.compSubMappingList[0].noOfQuestion = body.noOfQuestionsToAttempt;
  	body.compSubMappingList[0].testTimeoutMinute = body.testTimeoutMinute;
  	body.compSubMappingList[0].id = body.id;
  	    //Updating of Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesUpdateCompSubMappingList, body).subscribe((res: any)=>{
      //console.log(res);
      this.retrieveIndivCompSubMapping(this.loginUserByParam);
    });
  }
  
  deleteIndivCompSubMapping(index){
  	let body = this.getDefaultData();
  	body.noOfQuestionsToAttempt = this.indivCompSubMapping.value.compSubList[index].noOfQuestionsToAttempt;
  	body.testTimeoutMinute = this.indivCompSubMapping.value.compSubList[index].testTimeoutMinute;
  	body.id = this.indivCompSubMapping.value.id;
  	body.compSubMappingList.push(this.indivCompetitionSubjectMapping[index].compSubMappingList[0]);
  	//Deletion of Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesDeleteCompSubMappingList, body).subscribe((res: any)=>{
      //console.log(res);
      this.retrieveIndivCompSubMapping(this.loginUserByParam);
    });
  }
  
  addIndivCompSubMapping(index){
  	let body = this.getDefaultData();
  	body.noOfQuestionsToAttempt = this.indivCompSubMapping.value.compSubList[index].noOfQuestionsToAttempt;
  	body.testTimeoutMinute = this.indivCompSubMapping.value.compSubList[index].testTimeoutMinute;
  	body.marksCorrectAnswer = this.indivCompSubMapping.value.compSubList[index].marksCorrectAnswer;
  	body.marksWrongAnswer = this.indivCompSubMapping.value.compSubList[index].marksWrongAnswer;
  	body.marksSkipAnswer = this.indivCompSubMapping.value.compSubList[index].marksSkipAnswer;
  	body.compSubMappingList.push(this.competitionSubjectMapping[index]);
    
    //Creation of Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesCreateCompSubMappingList, body).subscribe((res: any)=>{
      if(this.dataService.redirectIfSessionaExpired(res) == false)
      		this.retrieveIndivCompSubMapping(this.loginUserByParam);
    });
  }
  
  
  getDefaultData(){
  	return {"id": null, "compSubMappingList" : [], loginUserId: this.loginUserByParam, 
  			noOfQuestionsToAttempt: 0, testTimeoutMinute:0, marksCorrectAnswer:1.0, marksWrongAnswer:0.0, marksSkipAnswer:0.0,
  			 baseData: 'Single' };
  }
  
  onSubmit(){
  
  }
  
  resetIndivCompSubMappingList(){
	let body = {"loginUserId" : this.loginUserByParam };
   
    //Individual's Competition Subject Mapping List
    this.dataService.sendPostRequestWithBody(UrlConstant.apiTestSeriesIndivCompSubMappingList, body).subscribe((res: any)=>{
     // console.log(res);
      this.indivCompetitionSubjectMapping = res.data;
    });
  }
}
